<div class="modal-header">
  <h2>
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
      <g fill="none" fill-rule="evenodd">
        <g fill="#0CC5D1">
          <path d="M32.786 0C33.456 0 34 .544 34 1.214v13.358c0 .322-.128.63-.356.858L15.43 33.644c-.474.475-1.243.475-1.717 0L.356 20.287c-.475-.474-.475-1.243 0-1.717L18.57.356c.228-.228.536-.356.858-.356zM31.57 2.429h-11.64l-17 17 11.64 11.64 17-17V2.429zM25.5 4.857c2.012 0 3.643 1.631 3.643 3.643 0 2.012-1.631 3.643-3.643 3.643-2.012 0-3.643-1.631-3.643-3.643 0-2.012 1.631-3.643 3.643-3.643zm0 2.429c-.67 0-1.214.543-1.214 1.214 0 .67.543 1.214 1.214 1.214.67 0 1.214-.543 1.214-1.214 0-.67-.543-1.214-1.214-1.214z" transform="translate(-704 -231) translate(440 199) translate(214 20) translate(0 12) translate(50)"></path>
        </g>
      </g>
    </svg>
    <ng-container>{{ itemTitle }}</ng-container>
  </h2>

  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
    <svg version="1.1" x="0px" y="0px" width="14" height="14" viewBox="0 0 14 14">
      <path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5" />
    </svg>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" class="fieldgroup edit w-100" (ngSubmit)="submit()" [attr.id]="formId" #formRef="ngForm">

    <fieldset [ngClass]="{'has-error': isSubmitted && form.controls.title.errors && form.controls.title.errors.required}">
      <label  i18n="@@invoices.item_name">Item name</label>
      <input type="text" name="title" formControlName="title" i18n-placeholder="@@placeholder.type_here" placeholder="Type Here" autocomplete="off" />
      <span class="field-error" *ngIf="form.controls.title.errors?.required" i18n="@@error.required">Required</span>
      <span class="field-error" i18n="@@error.required.delivery_type">Please Type Delivery Item</span>
    </fieldset>

    <fieldset [ngClass]="{'has-error': isSubmitted && form.controls.rate.invalid }">
      <label i18n="@@invoices.amount">Amount</label>
      <div class="tag-input">
        <input type="number" appPreventScroll name="rate" formControlName="rate" placeholder="{{ 0.00 | number:'.2' }}" autocomplete="off" />
        <span [innerHtml]="basicInfo.currency_symbol"></span>
      </div>
      <span class="field-error" *ngIf="form.controls.rate.errors?.required" i18n="@@error.required">Required</span>
      <span class="field-error" *ngIf="form.controls.rate.errors?.min" i18n="@@error.invalid_number">Invalid</span>
    </fieldset>

    <!-- <div class="check-section" *ngIf="isProPlan">
      <input class="styled-checkbox" id="add_to_store" type="checkbox" formControlName="add_to_store" >
      <label for="add_to_store">You want to add this item in your store?</label>
    </div> -->

  </form>
</div>

<div class="modal-footer">
  <button type="button" (click)="formRef.ngSubmit.emit()" class="tu-btn pink" i18n="@@clients.save">Save</button>
</div>